import { useReadEpisodePlayerBaseInfo } from '../../../hooks/use-read-episode-player-base-info';

export const useEpisodeSeasonContentId = (contentId: string) => {
    const episode = useReadEpisodePlayerBaseInfo(contentId);

    return episode?.season?.contentId ?? '';
};
